import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Bar, Pie } from "react-chartjs-2";
import { FirstCompBar, SecondPieChart } from "../../../../Helper/ChartDeta";
import Select from 'react-select'


// ChartJS.register(ArcElement, Tooltip, Legend);

export const ThirdCardComp = () => {

    const options = [
        { value: 'Meghalaya', label: 'Meghalaya' },
        { value: 'Manipur', label: 'Manipur' },
        { value: 'Mizoram', label: 'Mizoram' }
    ]


    const data = {
        labels: ['Arunachal Pradesh', 'Assam', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', "Tirupura", "West Bengal"
        ],
        datasets: [
            {
                label: '',
                data: [10, 20, 30, 40, 30, 40, 10, 20],
                fill: true,
                backgroundColor: [
                    'rgb(255, 99, 132, 0.8)',
                    'rgba(153, 102, 255, 0.8)',
                    'rgba(64, 106, 156, 0.9)',
                    'rgba(255, 206, 86, 0.8)',
                    'rgba(75, 192, 192, 0.8)',
                    'rgba(244, 83, 138, 0.9)',
                    'rgba(158, 64, 62, 0.9)',
                    'rgba(54, 162, 235, 0.8)'
                ],
                // borderColor: [
                //     'rgba(255, 99, 132, 1)',
                //     'rgba(54, 162, 235, 1)',
                //     'rgba(255, 206, 86, 1)',
                //     'rgba(75, 192, 192, 1)',
                //     'rgba(153, 102, 255, 1)',
                //     'rgba(255, 159, 64, 1)',
                //     'rgba(54, 162, 235, 1)',
                //     'rgba(255, 206, 86, 1)',
                //     'rgba(75, 192, 192, 1)',
                //     'rgba(153, 102, 255, 1)',
                //     'rgba(255, 159, 64, 1)',
                //     'rgba(75, 192, 192, 1)',
                //     'rgba(153, 102, 255, 1)',
                //     'rgba(255, 159, 64, 1)',
                // ],
                borderWidth: 0,

            },
        ],
    };

    const FirstCompdata = {

        labels: ['Polybag, Number', 'Cones (root-trainer), Number', 'Stumps, number', ],
        datasets: [
            {
                label: 'Crops',
                data: [4, 8, 13],

                fill: true,
                backgroundColor: [
                    'rgb(255, 99, 132, 0.8)',
                    'rgba(153, 102, 255, 0.8)',
                    'rgba(75, 192, 192, 0.8)',
                    // 'rgba(64, 106, 156, 0.9)',
                    // 'rgba(255, 206, 86, 0.8)',
                   
                    // 'rgba(244, 83, 138, 0.9)',
                    // 'rgba(158, 64, 62, 0.9)',
                    // 'rgba(54, 162, 235, 0.8)',
                    // 'rgba(144, 210, 109,0.9)',
                    // 'rgba(233, 64, 87, 0.9)',
                    // 'rgba(249, 150, 69, 0.8)',
                    // 'rgba(138,35,135, 0.8)',
                    // 'rgba(65, 176, 110, 0.8)',
                    // 'rgba(218, 170, 170, 0.9)',


                ],

            },
        ],
    };

    return (
        <>


            <div class="row bg-white border py-2 mt-4">
                {/* <h5 className="fw-bold ps-4 pt-2">Planting Material </h5>
                <hr className="mx-auto" style={{ width: '96%' }} /> */}
                <div className="row ps-4 pt-2 pb-2">
                    {/* <h6 className="fw-bold text-dark pb-2" style={{fontSize:'17px'}}>Intercropping Practice</h6> */}
                    <div class="col-12 col-lg-4 ">
                        <div class="row  shadow2  ms-0">
                            <div class="col-8 px-3 pt-3 ps-4 " style={{ backgroundColor: '#e9ecef', border: '1px solid #b9b9b936' }}>
                                <h6 className="fw-bold text-dark pb-2">Plant Type Distributed</h6>
                                <h3 className="fw-bold" style={{ color: 'rgb(239, 64, 105)' }}>1000</h3>
                            </div>
                            <div class="col-4 d-flex align-items-center justify-content-center" style={{
                                borderLeft: '1px solid #1b3066', backgroundColor: '#e9ecef',
                                border: '1px solid #b9b9b936'
                            }}>
                                <img src="./static/assets/img/dashboard/Area.png" alt="" style={{ width: "60%" }} />
                            </div>
                            <div className="col-12 col-lg-11 mx-auto py-4 bg-white ">
                                <Pie
                                    data={data}
                                    options={SecondPieChart}
                                    height={270}

                                />
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-8 shadow2 p-3" style={{ border: '1px solid #b9b9b936' }}>
                        <div className='row'>
                            <div className="col-12 col-md-8">
                                <h6 className="float-end fw-bold pt-3 pe-lg-5"> Plant Type Distributed </h6>

                            </div>
                            <div className="col-12 col-md-6 col-lg-4">
                                {/* <span>State</span> */}
                                <Select
                                    placeholder="State"
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            //   borderColor: state.isFocused ? 'grey' : 'red',
                                            borderColor: state.isFocused ? 'transparent' : 'transparent',
                                            borderBottomColor: '#000000',
                                            boxShadow: 'none',
                                            background: "#7490c430",
                                            // color:"white"
                                        }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            color: 'black'
                                        })
                                    }} options={options} />
                            </div>
                        </div>
                        <Bar
                            options={FirstCompBar}
                            data={FirstCompdata}
                            height={'130px'}
                        />
                    </div>
                </div>

                {/* <div class="col-12 col-lg-4 ">
                    <div class="row m-2 shadow2 border_yellow">
                        <div class="col-8 px-3 pt-3 ps-4 yellow">
                            <h6 className="fw-bold">Plant Type Distributed</h6>
                            <h3 className="fw-bold" style={{ color: 'rgb(69 107 176)' }}>1000</h3>
                        </div>
                        <div class="col-4 d-flex align-items-center justify-content-center" style=

                            {{ backgroundColor: 'rgb(69 107 176)' }}>
                            <img src="./static/assets/img/dashboard/PlantTypeDistributed.png" alt="" style=
                                {{ width: "70%" }} />
                        </div>
                        <div className="col-12 col-lg-11 mx-auto py-4 bg-white">
                            <Pie
                                data={data2}
                                options={SecondPieChart}
                                height={200}

                            />
                        </div>
                    </div>
                </div> */}

                {/* <div class="col-12 col-lg-4 ">
                    <div class="row m-2 shadow2 border_red">
                        <div class="col-8 px-3 pt-3 ps-4 red">
                            <h6 className="fw-bold">Saplings Not Received</h6>
                            <h3 className="fw-bold" style={{ color: '#EF4069' }}>1000</h3>
                        </div>
                        <div class="col-4 d-flex align-items-center justify-content-center" style=
                            {{ backgroundColor: 'rgba(239,64,105,1)' }}>
                            <img src="./static/assets/img/dashboard/saplings2.png" alt="" style={{ width: "70%" }} />
                        </div>
                        <div className="col-12 col-lg-11 mx-auto py-4 bg-white">
                            <Pie
                                data={data3}
                                options={SecondPieChart}
                                height={200}

                            />
                        </div>
                    </div>
                </div> */}

            </div>

            {/* <div class="row bg-white border py-2 mt-4">

                <div className="row ps-4 pt-2 pb-2">
                    <div className="col-9">
                        <h6 className="fw-bold text-dark pb-2" style={{ fontSize: '18px' }}>Intercropping Practice
                            <span className="fw-bold fs-3 ps-5" style={{ color: 'rgb(239, 64, 105)' }}>1000</span>
                        </h6>
                    </div>
                    <div className="col-3">
                        <Select
                            placeholder="State"
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderColor: state.isFocused ? 'transparent' : 'transparent',
                                    borderBottomColor: '#000000',
                                    boxShadow: 'none',
                                    background: "#7490c430",
                                }),
                                option: (provided, state) => ({
                                    ...provided,
                                    color: 'black'
                                })
                            }} options={options} />
                    </div>

                    <div class="col-12 col-lg-4 ">
                        <div class="row  shadow2  ms-0">

                            <div className="col-12 col-lg-11 mx-auto py-4 bg-white ">
                                <Pie
                                    data={data}
                                    options={SecondPieChart}
                                    height={290}

                                />
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-8 shadow2 p-3" style={{ border: '1px solid #b9b9b936' }}>
                        <div className='row'>
                            <div className="col-12 col-md-8">

                            </div>

                        </div>
                        <Bar
                            options={FirstCompBar}
                            data={FirstCompdata}
                            height={'130px'}
                        />
                    </div>
                </div>



            </div> */}


        </>
    )
}